export enum GrandchildrenOptionsEnum {
  'NONE' = 'NONE',
  'INCLUDE_GRANDCHILDREN' = 'INCLUDE_GRANDCHILDREN',
  'ONLY_GRANDCHILDREN' = 'ONLY_GRANDCHILDREN',
  'SPECIFIC_GRANDCHILDREN' = 'SPECIFIC_GRANDCHILDREN',
}
